<template>
	<div class="statistic-info">
		<!-- 导航 -->
		<van-nav-bar
		  title="销售统计详情"
		  left-text="返回"
		  left-arrow
		  @click-left="goBack"
		/>
		<!-- 详情信息 -->
		<div class="info-block">
			<van-cell title="退货金额" :value="statisticList.return_amount" />
			<van-cell title="退款单数" :value="statisticList.refund_count" />
			<van-cell title="退款金额" :value="statisticList.refund_amount" />
			<van-cell title="实际成交额" :value="actual_turnover" />
		</div>
	</div>
</template>

<script>
export default {
  name: 'StatisticInfo',
	components: {
	},
  data () {
    return {
			statisticList: []
    }
  },
	methods: {
		// 返回上一页
		goBack () {
			this.$router.go(-1)
		}
	},
	created () {
		this.statisticList = this.$route.params.statisticList
	}
}
</script>

<style lang="scss" scoped>
.statistic-info {
	font-size: 14px;
}
.statistic-info   ::v-deep.van-nav-bar {
	background-color: #e93b3d;
	color: white;
	.van-icon-arrow-left, .van-nav-bar__text, .van-nav-bar__title {
		color: white;
	}
}
</style>
